import { uncountable } from '@warp-drive/utilities/string';

export function initialize() {
  uncountable('search');
}

export default {
  name: 'custom-inflector-rules',
  initialize,
};
